export const puzzelKeys = {
  personByS2ID: (s2ID?: string | null) =>
    ['puzzel', 'person', 's2id', s2ID] as const,
};

export function parsePuzzelPersonByS2IDKey(
  queryKey: ReturnType<typeof puzzelKeys.personByS2ID>
) {
  const [, , , s2ID] = queryKey;
  return { s2ID };
}
